var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_54152",
    "data-name": "Group 54152",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54150",
    "data-name": "Group 54150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329",
    "data-name": "Rectangle 5329",
    width: 3.4,
    height: 3.4,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5330",
    "data-name": "Rectangle 5330",
    width: 3.4,
    height: 3.4,
    transform: "translate(3.4 3.4)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5331",
    "data-name": "Rectangle 5331",
    width: 3.4,
    height: 3.4,
    transform: "translate(6.8 6.8)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5332",
    "data-name": "Rectangle 5332",
    width: 3.4,
    height: 3.4,
    transform: "translate(10.2 10.2)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5333",
    "data-name": "Rectangle 5333",
    width: 3.4,
    height: 3.4,
    transform: "translate(13.6 13.6)",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54151",
    "data-name": "Group 54151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329-2",
    "data-name": "Rectangle 5329",
    width: 3.4,
    height: 3.4,
    transform: "translate(13.6)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5330-2",
    "data-name": "Rectangle 5330",
    width: 3.4,
    height: 3.4,
    transform: "translate(10.2 3.4)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5331-2",
    "data-name": "Rectangle 5331",
    width: 3.4,
    height: 3.4,
    transform: "translate(6.8 6.8)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5332-2",
    "data-name": "Rectangle 5332",
    width: 3.4,
    height: 3.4,
    transform: "translate(3.4 10.2)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5333-2",
    "data-name": "Rectangle 5333",
    width: 3.4,
    height: 3.4,
    transform: "translate(0 13.6)",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGe);
export default __webpack_public_path__ + "static/media/close-ge.79266398f0ccc2651ce386c2bf27118f.svg";
export { ForwardRef as ReactComponent };